import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	linkAll: {
		id: 'ai-related-issues.link-all',
		defaultMessage: 'Link all',
		description: 'Button text to link all suggested issues',
	},
});
